!<template>
    <div>
        <config-main-title>
            Configurações de Serviços PACS
        </config-main-title>


        <div class="row mb-3">
            <div class="col col-12 col-md-6">
                <az-input icon="fas fa-search" v-model="search" />
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn"
                        :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewMode = 'A'">
                        Ativos
                    </button>
                    <button type="button" class="btn"
                        :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewMode = 'T'">
                        Todos
                    </button>
                </div>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-success" @click="incluir_configuracao_servico_pacs()">
                    Incluir
                </button>
            </div>
        </div>

        <div v-if="lista && lista_filtrada.length > 0">
            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item" v-for="(configuracao, id) in lista_filtrada" :key="id">
                    <div class="d-flex justify-content-between">
                        <span class="h5 card-link mb-0 mr-3">
                            <a href="#" @click.prevent="editar_configuracao_servico_pacs(configuracao)">
                                {{ configuracao.search }}
                            </a>
                        </span>
                        <span>
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input"
                                    :id="'categoria-' + id "
                                    v-model="configuracao.fl_ativo"
                                    @change="alternar_status(configuracao)">
                                <label class="custom-control-label" :for="'categoria-' + id "></label>
                            </div>
                        </span>
                    </div>
                </li>
            </div>
        </div>

        <div v-else>
            <az-empty-state msg="Nenhum Serviço PACS Configurado..." icon="fas fa-x-ray" />
        </div>

        <div class="modal fade" id="modalConfiguracaoServicoPacs" tabindex="-1" role="dialog"
            aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Configurações do Serviço
                            <span class="badge badge-secondary ml-2" v-if="item.id_configuracao_pacs">#{{ item.id_configuracao_pacs }}</span>
                            <span class="badge badge-secondary ml-2" v-else>Nova</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Título" 
                                    required 
                                    placeholder="Título da configuração..."
                                    :validate="validate"
                                    v-model="item.st_titulo" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <AzInput 
                                    label="Serviço Pacs" 
                                    type="select" 
                                    placeholder="Selecione..."
                                    :optionsList="servicos_pacs"
                                    optionsData="name" 
                                    optionsDisplay="name" 
                                    :validate="validate"
                                    :edicao="!item.id_configuracao_pacs"
                                    v-model="item.js_configs.pacs"
                                    required />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Unidade"
                                    type="select"
                                    placeholder="Todas as unidades..."
                                    optionsData="id_unidade_operacao"
                                    :optionsList="$util.unidades_com_tags(false, true)"
                                    v-model="item.id_unidade_operacao"
                                    />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Status de Imagens Disponíveis"
                                    type="select"
                                    placeholder="Selecione..."
                                    service="status_laudos.index"
                                    optionsMode="aql"
                                    optionsData="id_status_laudo"
                                    :validate="validate"
                                    v-model="item.js_configs.id_status_laudo"
                                    />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Enviar Anexos"
                                    v-model="item.fl_enviar_anexos" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Enviar Laudo"
                                    v-model="item.fl_enviar_laudo" />
                            </div>
                        </div>

                        <div class="row mt-1">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Enviar Anamnese"
                                    v-model="item.fl_enviar_anamnese" />
                            </div>
                        </div>

                        <template v-if="item.js_configs.pacs && carregar_campos_servico(item.js_configs.pacs).length > 0">
                            <az-sub-title title="Campos" class="mt-3" />
                            <div v-for="(campo, index) in carregar_campos_servico(item.js_configs.pacs)" :key="index" >
                                <!-- <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend w-25">
                                        <span class="input-group-text w-100">{{ campo }}</span>
                                    </div> -->
                                    <az-input
                                        :label="campo"
                                        v-model="item.js_configs[campo]" 
                                        :type="campo == 'producao' ? 'checkbox-group' : ''"
                                        sizing="sm"
                                        class="mt-1"
                                    />
                                <!-- </div> -->
                            </div>
                        </template>

                        <div class="mt-3">
                            <az-sub-title title="De-Paras">
                                <a href="#" @click.prevent="incluir_depara()" class="card-link">
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                    Incluir De-Para
                                </a>
                            </az-sub-title>
                            <template v-for="(depara, idx) in item.deparas">
                                <div class="form-row" :key="idx" v-show="!depara.excluido">
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            sizing="sm"
                                            type="select"
                                            optionsMode="json"
                                            :optionsList="opcoes_depara"
                                            optionsData="id"
                                            :validate="validate"
                                            required
                                            :edicao="!depara.model_id"
                                            v-model="depara.model_type">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button class="btn btn-outline-danger" type="button" @click="depara.excluido = true">
                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>                                
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            sizing="sm"
                                            type="autocomplete"
                                            optionsMode="aql"
                                            :optionsSync="!infoFiltroModel(depara.model_type).nosync"
                                            :service="infoFiltroModel(depara.model_type).service" 
                                            :optionsName="'filtro-' + depara.model_type + infoFiltroModel(depara.model_type).name"
                                            :optionsParm="{ ativos: true, agenda: true, ...infoFiltroModel(depara.model_type).parms }"
                                            :edicao="( depara.model_type && !depara.model_id ) ? true : false"
                                            placeholder="Selecione..."
                                            v-model="depara.model">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append" v-if="depara.model_id">
                                                    <span class="input-group-text">
                                                        #{{ depara.model_id}}
                                                    </span>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            sizing="sm"
                                            icon="fa-solid fa-code"
                                            placeholder="De-Para..."
                                            v-model="depara.st_id_externo" />
                                    </div>
                                </div>
                            </template> 

                            <a href="#" @click.prevent="incluir_depara()" class="btn btn-outline-primary btn-sm">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </a>
                        </div>

                        <br><br><br><br><br><br><br><br>

                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button v-if="item.id_configuracao_pacs" model="configuracaoPacs" :id="item.id_configuracao_pacs" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">{{ item.id_configuracao_pacs ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import ConfigMainTitle from '../../cadastros/shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    components: {
        ConfigMainTitle,
        AzInput,
        AzSubmit,
        AzSubTitle,
        AzAuditLogButton
    },

    data() {

        return {
            lista: [],
            servicos_pacs: [],
            search: "",
            viewMode: 'A',
            item: null,
            validate: false, 
        }

    },

    computed: {

        opcoes_depara: function () { 
            let opcoes = [                        
                {id:'App\\azure\\local', search:'Local', service: 'locals.index', nosync: true }, 
            ];

            return opcoes;
        },

        lista_filtrada: function () {

            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ', '.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.lista.filter(item => {
                return (item.fl_ativo || this.viewMode == 'T') &&
                    (!this.search || reg.test(JSON.stringify(item)))
            });

        }
    },

    methods: {
        incluir_depara () { 
            this.item.deparas.push({
                model_type: "",
                model_id: "",
                st_id_externo: "", 
                excluido: false, 
            });
        },

        infoFiltroModel(model) { 
            if ( !this.opcoes_depara || !model ) 
                return {};

            let opcao = this.opcoes_depara.find(item => item.id == model);

            return opcao;
        },

        carregar() {

            this.$util.load(this, {
                service: 'configuracao_pacs',
                parms: { 
                    cadastro: true, 
                },
                loadTo: res => {
                    this.lista = res;
                }
            });

        },

        abrir_modal(item) {

            this.item = item;
            console.log(item);

            this.$util.load(this, {
                service: 'pacs_configuracao',
                loadTo: res => {
                    this.servicos_pacs = res;
                    $('#modalConfiguracaoServicoPacs').modal('show');
                }
            });
        },

        incluir_configuracao_servico_pacs() {

            let item = null;
            this.$nextTick(() => {

                item = {
                    'st_titulo': '',
                    'fl_ativo': true,
                    'id_unidade_operacao': '',
                    'js_configs': {
                        'id_pacs_service': '',
                        'id_status_laudo': ''
                    }
                };

                this.abrir_modal(item);
            });

        },

        editar_configuracao_servico_pacs(configuracao) {
            this.abrir_modal(configuracao);
        },

        alternar_status(configuracao) {

            this.$util.toggle(this, {
                service: 'configuracao_pacs',
                dados: configuracao,
            });

        },

        carregar_campos_servico(nome) {
            const servico = this.servicos_pacs.find(servico => servico.name == nome);

            if (servico && servico.js_configs) {
                return servico.js_configs;
            }

            return [];
        },

        atualizar() {

            this.$util.atualizar(this, {
                service: 'configuracao_pacs',
                dados: this.item,
                modal: 'modalConfiguracaoServicoPacs',
                callback: () => {
                    this.carregar();
                }
            });

        }

    },

    mounted() {
        this.carregar();

        this.breadcrumb = [
            { name: "Configurações", path: "/cadastros" },
            { name: "Configurações de Serviços Pacs", path: "" },
        ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);
    },
}
</script>
<style></style>
